module.exports = __webpack_public_path__ + "img/logo.0aa8925f.svg";